import React, { useCallback } from 'react';
import { Menu as RaMenu, DashboardMenuItem, MenuItemLink, Button, useLogout, useSidebarState } from 'react-admin';
import { ListItemIcon, MenuItem, Tooltip } from '@mui/material';

import UserIcon from '@mui/icons-material/Group';
import SettingsIcons from '@mui/icons-material/Settings';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import EmailIcon from '@mui/icons-material/Email';
import { useResourceAccess } from '../../hooks/useAccess';
import { collectionsAdminUrl } from './collectionsAdminUrl';

export const Menu: React.FC = () => {
  const logout = useLogout();
  const [sidebarOpen] = useSidebarState();

  const handleLogout = useCallback(() => {
    logout();
  }, []);

  const {
    DashboardView,
    UserSearchView,
    ApplicationSearchView,
    RepaymentSearchView,
    SettingsDetailsView,
    MCCSearchView,
    ActivitySearchView,
    CollectionsView,
  } = useResourceAccess();

  return (
    <RaMenu>
      {DashboardView() && <DashboardMenuItem />}
      {UserSearchView() && <MenuItemLink to="/users" primaryText="Users" leftIcon={<UserIcon />} />}
      {ApplicationSearchView() && (
        <MenuItemLink
          to="/creditdecisionapplications"
          primaryText="Applications"
          leftIcon={<FormatListBulletedIcon />}
        />
      )}
      {RepaymentSearchView() && (
        <MenuItemLink to="/repayment" primaryText="Repayment" leftIcon={<FormatListBulletedIcon />} />
      )}
      {SettingsDetailsView() && <MenuItemLink to="/settings" primaryText="Settings" leftIcon={<SettingsIcons />} />}
      {MCCSearchView() && <MenuItemLink to="/mcc" primaryText="MCC" leftIcon={<SettingsIcons />} />}
      {ActivitySearchView() && (
        <MenuItemLink to={{ pathname: '/history' }} primaryText="Activity" leftIcon={<SettingsIcons />} />
      )}
      {CollectionsView() && (
        <Tooltip title={sidebarOpen ? '' : 'Collections'} placement="right">
          <MenuItem
            component="a"
            href={collectionsAdminUrl(window.location.hostname)}
            target="_blank"
            rel="noopener noreferrer"
          >
            <ListItemIcon sx={{ minWidth: (theme) => theme.spacing(5) }}>
              <EmailIcon />
            </ListItemIcon>
            Collections
          </MenuItem>
        </Tooltip>
      )}
      <Button onClick={handleLogout}>
        <>Logout</>
      </Button>
    </RaMenu>
  );
};
